import classnames from 'classnames';
import React, { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { ModalName } from '../../../constants/ModalName';
import { TrackAddToBoardPopUpTarget, useTrackBoardAnalytics } from '../../../utils/hooks/bi/useTrackBoardAnalytics';
import { useModalHandlersAndOptions } from '../../../utils/hooks/useModal';
import { ContextMenuItem, SubMenu } from '..';
import { Add } from '../WixIcons';
import styles from './BoardsContextMenu.scss';
import { IOuter } from './BoardsContextMenu.types';
import { BoardsList } from './BoardsList';

const BoardsContextMenuContent: FC<IOuter> = ({ itemsToAdd }) => {
  const { openModal } = useModalHandlersAndOptions(ModalName.EditBoard);

  const { trackAddToBoardMenuClick } = useTrackBoardAnalytics();

  const handleCreateNewBoardClick = useCallback(
    (_event, params) => {
      const clickOrigin = params.contextMenuOrigin;

      openModal({ selectedItems: itemsToAdd, clickOrigin });
      trackAddToBoardMenuClick(itemsToAdd, {
        target: TrackAddToBoardPopUpTarget.New,
        clickOrigin,
      });
    },
    [openModal, trackAddToBoardMenuClick, itemsToAdd],
  );

  return (
    <>
      <BoardsList itemsToAdd={itemsToAdd} />

      <ContextMenuItem
        icon={<Add />}
        iconClassName={styles.newBoardLabel}
        title={<FormattedMessage id="boards.context-menu.new-board" />}
        titleTextSize="medium"
        titleClassName={classnames(styles.newBoardLabel, styles.boardLabel)}
        dataHook="boards-context-menu-new-board"
        onClick={handleCreateNewBoardClick}
        menuItemClassName={styles.addToBoardContextMenuFooter}
        ellipsis
      />
    </>
  );
};

export const BoardsContextMenu: FC<IOuter> = ({ itemsToAdd }) => (
  <>
    <ContextMenuItem
      title={<FormattedMessage id="boards.context-menu.add-to-board" />}
      titleTextSize="medium"
      titleClassName={styles.boardLabel}
      dataHook="boards-context-menu-add-to-board"
      menuItemClassName={styles.addToBoardContextMenuHeader}
      ellipsis
    />
    <BoardsContextMenuContent itemsToAdd={itemsToAdd} />
  </>
);

export const BoardsContextSubMenuContent: FC<IOuter> = ({ itemsToAdd }) => (
  <SubMenu
    title={<FormattedMessage id="boards.context-menu.add-to-board" />}
    className={styles.boardsContextMenu}
    dataHook="context-menu.add-to-board-sub-menu"
  >
    <BoardsContextMenuContent itemsToAdd={itemsToAdd} />
  </SubMenu>
);
